import {
  FETCHING_JOB_RECURRING_LIST,
  JOB_RECURRING_LIST_FETCHED
} from '../actions/jvpJobRecurring'

const INITIAL_STATE = {
  jobList: { list: [], total: 0, ts: Date.now() },
  loadingList: true,
  isLoaded: false
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCHING_JOB_RECURRING_LIST:
      return handleFetchingJobRecurringList(state, action)
    case JOB_RECURRING_LIST_FETCHED:
      return handleJobRecurringListFetched(state, action)
    default:
      return state
  }
}

function handleFetchingJobRecurringList (state, action) {
  const { loadingList, isLoaded } = action
  return { ...state, loadingList, isLoaded: isLoaded === null || isLoaded === undefined ? state.isLoaded : isLoaded }
}

function handleJobRecurringListFetched (state, action) {
  const { jobs, loadingList } = action
  return { ...state, jobList: jobs, loadingList, isLoaded: true }
}

